//index.js
import Client from "./client";
import { getOssStsApi } from "@/api" //获取后台返回sts信息

export const getAliToken = (that) => {
    //获取Token
    return new Promise((resolve, reject) => {
        getOssStsApi().then((res) => {
                console.log("res :>> ", res)
                if (res.data.StatusCode === 200) {
                    const {
                        AccessKeyId,
                        AccessKeySecret,
                        SecurityToken,
                    } = res.data;
                    //后台返回的存放路径
                    that.videoOssAddress = "zuhubao";
                    that.imgOssAddress = "zuhubao";
                    // this.expiration = expiration;
                    that.dataObj = {
                        region: "oss-cn-shanghai",
                        bucket: "shanghai-resource",
                        accessKeyId: AccessKeyId,
                        accessKeySecret: AccessKeySecret,
                        stsToken: SecurityToken
                    };
                    console.log(that.dataObj);
                    resolve(res);
                } else {
                    reject(false);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    })

};

// 上传视频 oss直传
export const ossUpload = async(option, dataObj, route, callback) => {
    // console.log(option, dataObj, route, callback);
    const client = Client(dataObj)
    const file = option.file;

    //随机命名
    const random_name =
        random_string(6) +
        "_" +
        new Date().getTime() +
        "." +
        file.name.split(".").pop();

    //上传失败的话 可以放开下方注释代码 试试
    client.options.endpoint.protocol = "https:";
    // 分片上传文件
    await client
        .multipartUpload(`/${route}/${random_name}`, file, {
            progress: async function(p) {
                let e = {};
                e.percent = p * 100;
                option.onProgress(e);
            },
        })
        .then((res) => {
            console.log(res);
            callback(res)
        })
}

// 随机生成文件名
export const random_string = (len) => {
    len = len || 8;
    let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678",
        maxPos = chars.length,
        pwd = "";
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
};